// One-tap light ⇄ dark, next to the bell (owner 2026-10-03). It flips what is
// on screen now by saving the opposite choice; « Auto » is still chosen in
// « More » › Apparence and Paramètres (AppearanceSwitch).
import { useT } from '@/lib/i18n';
import { useAdminTheme } from '@/lib/theme/adminTheme';

export function ThemeToggle() {
  const { t } = useT();
  const { mode, setPref } = useAdminTheme();
  const dark = mode === 'dark';
  const label = dark ? t('Passer en mode clair') : t('Passer en mode sombre');
  return (
    <button
      type="button"
      data-theme-toggle
      aria-label={label}
      title={label}
      onClick={() => setPref(dark ? 'light' : 'dark')}
      className="w-11 h-11 inline-flex items-center justify-center rounded-full text-adm-muted hover:bg-adm-gold-wash transition-colors"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" aria-hidden>
        {dark
          ? <><circle cx="12" cy="12" r="4" /><path d="M12 2.5v2M12 19.5v2M4.6 4.6l1.4 1.4M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4L6 18M18 6l1.4-1.4" /></>
          : <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" />}
      </svg>
    </button>
  );
}
